var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 10.4991V12.2819H17.9069C17.4858 12.2819 17.2184 12.3604 17.1051 12.5165C16.9594 12.6885 16.8866 12.9313 16.8866 13.2436V14.5108H18.9272L18.6598 16.5046H16.8866V21.5716H14.7732V16.5046H13V14.5108H14.7732V13.0561C14.7732 12.2428 15.0081 11.5942 15.4776 11.1091C15.9796 10.6556 16.6276 10.4287 17.4209 10.4287C18.085 10.4287 18.6113 10.4523 19 10.4991Z",
  fill: "white"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 15.5,
  stroke: "white"
})));
export default SvgIconFacebook;